import React from "react";
import styles from "./OrderableSementsFilter.module.scss";
import { Flex, Checkbox, Popup, RadioGroup } from "@fluentui/react-northstar";
import { Selectable } from "../models/abstractions/Selectable";

export interface OrderableSementsFilterProps {
    trigger: JSX.Element;
    items: Selectable[];
    multiple?: boolean;
    onSelectedItemsChanged: (items: Selectable[]) => void;
    atLeastOneAlwaysSelected?: boolean;
    disabled?: boolean;
}

export const OrderableSementsFilter: React.FC<OrderableSementsFilterProps> = ({
    trigger,
    items,
    multiple,
    onSelectedItemsChanged,
    atLeastOneAlwaysSelected,
    disabled,
}) => {
    const selectedItems = items.filter((item) => item.selected);

    let content: React.ReactNode;
    if (multiple) {
        content = (
            <Flex column>
                {items.map((item) => (
                    <Checkbox
                        key={item.key}
                        label={item.content}
                        checked={item.selected}
                        disabled={disabled || (atLeastOneAlwaysSelected && selectedItems.length == 1 && item.selected)}
                        onChange={() => {
                            const newItems = items.slice();
                            const checkedItem = newItems.find((newItem) => newItem.key === item.key);
                            if (checkedItem) {
                                checkedItem.selected = !checkedItem.selected;
                            }
                            onSelectedItemsChanged(newItems);
                        }}
                    />
                ))}
            </Flex>
        );
    } else {
        const selectedItemValue = selectedItems.length > 0 ? selectedItems[0].key : undefined;
        content = (
            <RadioGroup
                vertical
                checkedValue={selectedItemValue}
                items={items.map((item): any => ({
                    key: item.key,
                    label: item.content,
                    value: item.key,
                    className: styles.radioItem,
                    disabled: disabled,
                }))}
                onCheckedValueChange={(_, data) => {
                    const newItems = items.slice();
                    newItems.forEach((item) => (item.selected = false));
                    const checkedItem = newItems.find((item) => item.key === data?.value);
                    if (checkedItem) {
                        checkedItem.selected = true;
                    }
                    onSelectedItemsChanged(newItems);
                }}
            />
        );
    }

    return <Popup trigger={trigger} content={content} position="below" align="end" />;
};
